import React from 'react';
import styles from './broadcastPopup.module.css'
import IMAGES from '../../assets/images/images';
import { useBodyScrollLock } from '../../utils/utils';

const BroadCastPopup = ({ onConfirm, onCancel, data = '', header = "", showPopup=false}) => {
    useBodyScrollLock(showPopup);
    return (
        <div className={styles.confirmationpopup}>
            <div className={styles.confirmationpopupcontent}>
                {/* <div className={styles.header}><div><img onClick={onCancel} className={styles.close} src={IMAGES.close} /></div></div> */}
                <div className={styles.detailcontainor}>
                    <div><img onClick={onCancel} className={styles.imgmessage} src={IMAGES.messageicon} /></div>
                    <div className={styles.detail}>
                        <div className={styles.headertxt}>{header}</div>
                        <div className={styles.datatxt}>
                            {data?.split('\n').map((line, index) => (
                               <span className={styles.rowgap} key={index}>{line}<br/></span>))}
                        </div>
                    </div>
                </div>
                <div onClick={onCancel} className={styles.close}>Ok</div>
            </div>
        </div>
    );
};

export default BroadCastPopup;
